// The Customers page's sub-pages: the customers board and the CRM Merges
// worklist. The tab is kept in the URL (`customers-tab`) so a link to the
// worklist can be shared (the staff feed's merge notifications land there).
export const CUSTOMER_TABS_ID = "customers"
export const CUSTOMER_VIEW_ALL = "all"
export const CUSTOMER_VIEW_CRM_MERGES = "crm-merges"

/** The Customers page landed on the CRM Merges worklist (same `${id}-tab` param Tabs persists, tabs.utils). */
export const CUSTOMER_CRM_MERGES_HREF = `/customers?${CUSTOMER_TABS_ID}-tab=${CUSTOMER_VIEW_CRM_MERGES}`
